import { Box } from 'roo-ui/components';

const MessageBoard = (props) => <Box px={[4, 5]} py={[3]} border={1} borderColor="blue" bg="lightBlue" {...props} />;

export default MessageBoard;
